import * as DateFns from 'date-fns';

import type { Order } from '@order/graphql';
import { ignoreTimezone } from '@order/utils';

import { getOrderTime } from './getOrderTime';

/**
 * Orders are considered expired if their completed time is 72hrs in the past.
 */
export const checkIfExpiredOrder = ({ order }: IsOrderExpiredProps) => {
  const orderTime = order ? getOrderTime(order) ?? '' : '';
  const orderTimeDate = orderTime ? ignoreTimezone(orderTime) : undefined;

  const seventyTwoHoursAgo = DateFns.subHours(new Date(), 72);
  const isExpired = orderTimeDate
    ? DateFns.isBefore(orderTimeDate, seventyTwoHoursAgo)
    : false;

  return isExpired;
};

type IsOrderExpiredProps = {
  readonly order?: Partial<Order>;
};
